export const roleList = [
  {
    "id": 19,
    "name": "CTV",
    "nameDisplay": "Thao tác đơn hàng",
    "description": "User is the owner of a given project",
  },
  {
    "id": 20,
    "name": "CTV",
    "nameDisplay": "Thao tác đơn hàng",
    "description": "User is the owner of a given project",
  },
  {
    "id": 21,
    "name": "CTV",
    "nameDisplay": "Thao tác đơn hàng",
    "description": "User is the owner of a given project",
  },
  {
    "id": 22,
    "name": "CTV",
    "nameDisplay": "Thao tác đơn hàng",
    "description": "User is the owner of a given project",
  },
  {
    "id": 23,
    "name": "CTV",
    "nameDisplay": "Thao tác đơn hàng",
    "description": "User is the owner of a given project",
  },
  {
    "id": 24,
    "name": "CTV",
    "nameDisplay": "Thao tác đơn hàng",
    "description": "User is the owner of a given project",
  },
  {
    "id": 25,
    "name": "CTV",
    "nameDisplay": "Thao tác đơn hàng",
    "description": "User is the owner of a given project",
  },
  {
    "id": 26,
    "name": "CTV",
    "nameDisplay": "Thao tác đơn hàng",
    "description": "User is the owner of a given project",
  }
].map((item) => ({ 
  Index: item.id, 
  ["Tên"]: item.name,/** eslint-disable no-useless-computed-key */
  ["DisplayName"]: item.nameDisplay,
  ["Description"]: item.description,
}));

export const languageList = [
  {
    "id": 4,
    "code": "vi",
    "name": "Tiếng Việt",
    "priority": 1,
    "flag_icon": "https://dashboard.epispost.com//cms/images/assets/no-img_50x50.png",
    "vi_name": null,
    "created_at": null,
    "updated_at": "2020-07-21T13:22:43.000000Z",
    "deleted_at": null
  }
].map((item) => ({
  id: item.id,
  value: item.code,
  label: item.name
}));

export const statusList = [
  {
    id: '1',
    value: 'active',
    label: 'Active'
  },
  {
    id: '2',
    value: 'de_active',
    label: 'DeActive'
  }
]

export const currencyList = [{ id: 1, value: "VND", label: "Việt Nam Đồng" }, { id: 1, value: "AUD", label: "Đô la Úc" }]

export const shipServiceList = [
  {
    id: 1,
    value: "2",
    label: "Standard"
  },
  {
    id: 2,
    value: "1",
    label: "Express"
  }
]
